
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "SEO 2026 : toutes les astuces pour améliorer votre référencement",
    description:
      "Découvrez les meilleures pratiques SEO de 2026 pour booster votre visibilité en ligne : conseils, techniques et stratégies pour un référencement optimal.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
